module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_2_preview.e6cbe0bb.jpg";